import { graphql } from "react-relay";

export const load_enrolment = graphql`
  query LoadEnrolmentQuery($enrolmentId: ID!) {
    enrolment(id: $enrolmentId) {
      id
      pupilFirstName
      pupilLastName
      school {
        id
        name
        archived
      }
      schoolName
      schoolBorough
      schoolPostcode
      schoolYear
      schoolClass
      lessonStage
      lessonType
      instrument
      teacherEmail
      parentName
      parentEmail
      parentPhoneNumber
      hasInvalidParentPhoneNumber
      pupilNotes
      adminNotes
      positionInWaitingList
      status
      createdTimestamp
      enroledTimestamp
      archivedTimestamp
      lastOfferedTimestamp
      enroledPupil {
        id
      }
      enroledParent {
        id
      }
      potentialDuplicates {
        edges {
          node {
            id
            pupilFirstName
            pupilLastName
          }
        }
      }
      potentialDuplicatePupils {
        edges {
          node {
            id
            primaryParent {
              id
              accountNumber
            }
            user {
              id
              firstName
              lastName
            }
          }
        }
      }
      offers {
        edges {
          node {
            id
            offerTimestamp
            offerAccepted
            archived
            enrolment {
              id
              pupilFirstName
              pupilLastName
            }
            lessonBlock {
              id
              lessonDay
              lessonTime
              lessonStage {
                id
                stage
                lessonType
                lessonDuration
              }
              instrument {
                id
                name
              }
              teacher {
                id
                user {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  }
`;
